export default "__VITE_ASSET__Bp8SHZ62__"